import hasStorage from './hasStorage'
import CookieStorage, { hasCookies } from './LocalCookieStorage'

let fallbackLogicLocalStorage = null;

if (hasStorage('localStorage')) {
    fallbackLogicLocalStorage = window.localStorage;
} else if(hasCookies()) {
    fallbackLogicLocalStorage = new CookieStorage();
} else {
    throw new Error("No suitable storage found");
}

export const fallbackLocalStorage = fallbackLogicLocalStorage;

let fallbackLogicSessionStorage = null;

if (hasStorage('sessionStorage')) {
    fallbackLogicSessionStorage = window.sessionStorage;
} else if(hasCookies()) {
    fallbackLogicSessionStorage = new CookieStorage();
} else {
    throw new Error("No suitable storage found");
}

export const fallbackSessionStorage = fallbackLogicSessionStorage;



// WEBPACK FOOTER //
// ./resources/modules/shared/helpers/storage-cookie-fallback/index.ts